module.exports = __webpack_public_path__ + "static/Gotham-ThinItalic-d8582ea032523ba359a9de5f89917e80.woff";